import { useFlyOutProductsBasedOnSelectedCloud } from '../../../common/utils/hooks/useFlyOutProductsBasedOnSelectedCloud'
import React, { useEffect } from 'react'
import {
  useCurrentCloudProvider,
  useAccountId,
  useGetAllUsers,
  useGetUsers,
} from '@labrav/common'
import { useParams } from 'react-router-dom'
import { isEmpty } from 'lodash'
import { useDispatch, useSelector } from '../../../store'
import { getCurrentResaleAuthorization } from '../../../modules/resaleAuthorization/utils/getCurrentResaleAuthorization'
import { ViewDetailsResellerAuthorization } from '../ViewDetailsResellerAuthorization/ViewDetailsResellerAuthorization'
import { getCurrencySymbol } from '../../../common/utils/getCurrencySymbol'
import { useSyncFlyoutRouteParams } from '../../../common/utils/hooks/useSyncFlyoutRouteParams'
import type { ViewSentResellerAuthorizationProps } from '../types'
import type { ViewResellerAuthorizationType } from '../../../modules/receivedResellerAuthorization/types'
import type { Product } from '../../../modules/productsListing/types'
import type { ResaleAuthorizationsResellerAgreements } from '../../../types/resaleAuthorization'

export type { ViewSentResellerAuthorizationProps }

export const ViewSentResellerAuthorization: React.FC<
  ViewSentResellerAuthorizationProps
> = ({ crmOpportunityId, externalBaseURL, search, onBack }) => {
  const { users } = useGetAllUsers()
  const { users: recipientStakeholderUsers } = useGetUsers()

  useSyncFlyoutRouteParams()

  const dispatch = useDispatch()
  const { accountId: routeAccountId } = useParams<{
    accountId: string
  }>()
  const fallbackAccountId = useAccountId({ product: 'flyout' }) || ''
  const accountId = routeAccountId || fallbackAccountId
  const { resaleAuthorizationId: resaleAuthorizationIdParam, productId } =
    useParams<{
      productId: string
      resaleAuthorizationId: string
    }>()
  const resaleAuthorizationId = resaleAuthorizationIdParam as string

  const { products } = useFlyOutProductsBasedOnSelectedCloud({
    microsoftResellerAuthorization: true,
  })
  const cloudMarketplace = useCurrentCloudProvider({
    microsoftResellerAuthorization: true,
  })
  const { sentResaleAuthorization, product } = useSelector(state => {
    const sentResaleAuthorization = (state.cppoReseller
      ?.currentResaleAuthorization?.[resaleAuthorizationId] ||
      {}) as ResaleAuthorizationsResellerAgreements
    const product = products.find(product =>
      cloudMarketplace === 'AWS'
        ? product.productId ===
            sentResaleAuthorization?.products?.[0]?.awsProductId ||
          product.productId === sentResaleAuthorization?.awsProductId
        : product.productId === productId
    )
    return {
      sentResaleAuthorization,
      product,
    }
  })

  useEffect(() => {
    if (!(crmOpportunityId || externalBaseURL) && !isEmpty(accountId)) {
      {
        dispatch(
          getCurrentResaleAuthorization({
            cloud: cloudMarketplace,
            partnerId: accountId,
            resaleAuthorizationId,
            crmOpportunityId,
            productId,
          })
        )
      }
    }
  }, [
    accountId,
    resaleAuthorizationId,
    cloudMarketplace,
    crmOpportunityId,
    productId,
    externalBaseURL,
  ])
  const currencySymbol = getCurrencySymbol(
    sentResaleAuthorization?.currency as string
  )

  return isEmpty(sentResaleAuthorization) ? (
    <div data-testid="empty-reseller-authorization"></div>
  ) : (
    <>
      <div data-testid="sent-reseller-authorization">
        <ViewDetailsResellerAuthorization
          resellerAuthorization={
            sentResaleAuthorization as ViewResellerAuthorizationType
          }
          crmOpportunityId={crmOpportunityId}
          product={product as Product | undefined}
          cloudMarketplace={cloudMarketplace}
          currencySymbol={currencySymbol}
          externalBaseURL={externalBaseURL}
          search={search}
          onBack={onBack}
          users={users}
          recipientStakeholderUsers={recipientStakeholderUsers}
        />
      </div>
    </>
  )
}
